/**
 * Spec 062 — ready-made offer banners for partners without a design.
 *
 * Bundled with the portal (Vite hashes them into /assets). Picking one fetches the asset
 * and runs it through the normal BannerUploader path (checks → 2:1 crop → upload-url →
 * confirm), so the stored banner lives under the partner's own
 * `garages/{garageId}/promotion_banner/` key like any uploaded file.
 * All are text-free 1600×800 JPG backgrounds (colour only, no wording).
 */
import navyYellow from '../../assets/offer-banner-templates/01-navy-yellow.jpg';
import teal from '../../assets/offer-banner-templates/02-teal.jpg';
import charcoalOrange from '../../assets/offer-banner-templates/03-charcoal-orange.jpg';
import green from '../../assets/offer-banner-templates/04-green.jpg';
import burgundy from '../../assets/offer-banner-templates/05-burgundy.jpg';

export interface BannerTemplate {
  id: string;
  /** `offers.banner.template.*` label key. */
  labelKey: string;
  src: string;
  fileName: string;
}

export const BANNER_TEMPLATES: readonly BannerTemplate[] = [
  { id: 'navy-yellow', labelKey: 'offers.banner.template.navyYellow', src: navyYellow, fileName: '01-navy-yellow.jpg' },
  { id: 'teal', labelKey: 'offers.banner.template.teal', src: teal, fileName: '02-teal.jpg' },
  { id: 'charcoal-orange', labelKey: 'offers.banner.template.charcoalOrange', src: charcoalOrange, fileName: '03-charcoal-orange.jpg' },
  { id: 'green', labelKey: 'offers.banner.template.green', src: green, fileName: '04-green.jpg' },
  { id: 'burgundy', labelKey: 'offers.banner.template.burgundy', src: burgundy, fileName: '05-burgundy.jpg' },
];

/** Fetches a bundled template as a File, ready for the normal upload path. */
export async function fetchTemplateFile(template: BannerTemplate): Promise<File> {
  const res = await fetch(template.src);
  if (!res.ok) throw new Error(`TEMPLATE_FETCH_FAILED_${res.status}`);
  const blob = await res.blob();
  // Always JPEG: the server's Content-Type for a static asset must not decide the type check.
  return new File([blob], template.fileName, { type: 'image/jpeg' });
}
